import React, {useEffect, useState} from 'react';

import {hooks} from '../hooks';

export const PwaInstallPrompt: React.FC = () => {
  const {canUsePrompt, install, isInstalled, isIos, isMobile} =
    hooks.usePwaInstall();
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [manualHint, setManualHint] = useState(false);

  useEffect(() => {
    if (isInstalled || dismissed || (!canUsePrompt && !isIos && !isMobile)) {
      setVisible(false);
      return;
    }

    const timer = window.setTimeout(() => setVisible(true), 1000);

    return () => window.clearTimeout(timer);
  }, [canUsePrompt, dismissed, isInstalled, isIos, isMobile]);

  if (!visible || isInstalled) return null;

  const handleInstall = async () => {
    const outcome = await install();

    if (outcome === 'accepted') {
      setVisible(false);
      return;
    }

    if (outcome === 'manual' || outcome === 'unavailable') {
      setManualHint(true);
    }
  };

  const closePrompt = () => {
    setDismissed(true);
    setVisible(false);
  };

  return (
    <div
      className='install-banner'
      role='dialog'
      aria-modal='false'
    >
      <button
        className='install-banner__close'
        onClick={closePrompt}
        type='button'
        aria-label='İndirme mesajını kapat'
      >
        ×
      </button>
      <div className='install-banner__copy'>
        <span className='install-banner__eyebrow'>The Most Beauty</span>
        <strong>Telefona indir</strong>
        {manualHint && (
          <p>
            {isIos
              ? 'Safari paylaş menüsünden Ana Ekrana Ekle seçeneğini kullanın.'
              : 'Tarayıcı menüsünden ana ekrana ekleyebilirsiniz.'}
          </p>
        )}
      </div>
      <button
        className='install-banner__button'
        onClick={handleInstall}
        type='button'
      >
        İndir
      </button>
    </div>
  );
};
